const createSafetyCode = async (provider) => {
  const latestBlockNumber = await provider.getBlockNumber()
  const actualTimeStamp = (await provider.getBlock(latestBlockNumber)).timestamp
  return Math.floor((actualTimeStamp * 1000 + 5 * 60 * 1000) / 1000)
}

export default createSafetyCode
